import {
  type SumsubVerificationConfig,
  SumsubVerificationPage,
} from '../SumsubVerificationPage';

const kycConfig: SumsubVerificationConfig = {
  levelName: 'dapp-store-kyc',
  pageTitle: 'Identity Verification | Publishing Portal',
  sdkTitle: 'Identity Verification',
  verificationType: 'identity',
  shouldRedirect: (publisherType) => publisherType !== 'Individual',
  redirectPath: '/dashboard/submit-kyb',
};

interface Props {
  className?: string;
}

export function SubmitKycPage(props: Props) {
  return (
    <SumsubVerificationPage className={props.className} config={kycConfig} />
  );
}
